module.exports = __webpack_public_path__ + "static/media/commentary-duotone.07578418.svg";